const fieldMap = {
  state: 'State',
  total: 'Total Cases',
  activecase: 'Active Cases',
  newcases: 'New Cases',
  death: 'Deaths',
  newdeath: 'New Deaths',
  deathrate: 'CFR',
  positiverate: 'Positive %',
  testperm: 'Tests / 1M',
  deathperm: 'Deaths / 1M',
  caseperm: 'Cases / 1M',
  deathpktest: 'Deaths / 1K test',
  'J-value': 'J-value',

  country: 'Country',
  recoverrate: 'Recovery %',

  county: 'County',
  cases: 'Total Cases',
  deaths: 'Deaths',
  avgrate3: 'Cases 3-day Avg.',
  avgrate7: 'Cases 7-day Avg.',
  deathrate7: 'Deaths 7-day Avg.',
  cfr: 'CFR',
  CFR: 'CFR',
  weekrate: 'Cases 1-wk Avg.',
  deathrate3: 'Deaths 3-wk Avg.',

  metro: 'Metro',
  dt: 'Date',
  newdeaths: 'New Deaths',
  weekrate3: 'Cases 3-wk Avg.',
  weekrate7: 'Cases 7-wk Avg',
  population: 'Population',
}
const stateNames = {
  US:	"United States of America",
  AL:	"Alabama",
  AK:	"Alaska",
  AZ:	"Arizona",
  AR:	"Arkansas",
  CA:	"California",
  CO:	"Colorado",
  CT:	"Connecticut",
  DE:	"Delaware",
  DC:	"District of Columbia",
  FL:	"Florida",
  GA:	"Georgia",
  HI:	"Hawaii",
  ID:	"Idaho",
  IL:	"Illinois",
  IN:	"Indiana",
  IA:	"Iowa",
  KS:	"Kansas",
  KY:	"Kentucky",
  LA:	"Louisiana",
  ME:	"Maine",
  MD:	"Maryland",
  MA:	"Massachusetts",
  MI:	"Michigan",
  MN:	"Minnesota",
  MS:	"Mississippi",
  MO:	"Missouri",
  MT:	"Montana",
  NE:	"Nebraska",
  NV:	"Nevada",
  NH:	"New Hampshire",
  NJ:	"New Jersey",
  NM:	"New Mexico",
  NY:	"New York",
  NC:	"North Carolina",
  ND:	"North Dakota",
  OH:	"Ohio",
  OK:	"Oklahoma",
  OR:	"Oregon",
  PA:	"Pennsylvania",
  RI:	"Rhode Island",
  SC:	"South Carolina",
  SD:	"South Dakota",
  TN:	"Tennessee",
  TX:	"Texas",
  UT:	"Utah",
  VT:	"Vermont",
  VA:	"Virginia",
  WA:	"Washington",
  WV:	"West Virginia",
  WI:	"Wisconsin",
  WY:	"Wyoming",
  AS:	"American Samoa",
  GU:	"Guam",
  MP:	"Northern Mariana Islands",
  PR:	"Puerto Rico",
  VI:	"U.S. Virgin Islands",
  FM:	"Micronesia",
  MH:	"Marshall Islands",
  PW:	"Palau"
}

export {
  fieldMap, stateNames
}
